export default "__VITE_ASSET__BBtS0SoK__"